import { LocalTrack } from 'models/LocalTrack';
import { TrackRequest } from 'models/TrackRequest';
import { useTrackMapping } from './useTrackMapping';

export function useLocalPlaylist() {
  const { getMappedTrack } = useTrackMapping();

  const getLocalPlaylist = async (requests: TrackRequest[]): Promise<LocalTrack[]> => {
    const localTracks: LocalTrack[] = [];

    for (const request of requests) {
      if (!request.isDeleted && request.localId !== null) {
        const localTrack = await getMappedTrack(request);

        if (localTrack) {
          localTracks.push(localTrack);
        }
      }
    }

    return localTracks;
  };

  return {
    getLocalPlaylist,
  };
}
